import Product from '@common/models/Product';
import { fetchProductDetailsRequest, fetchProductReviewsRequest } from '@common/store/productDetails/slice';
import { removeToast, ToastWithKeyType } from '@common/store/toasts/slice';
import history from '@common/utils/history';
// import Details from '@images/Zoom.svg';
// import Image from '@lib/Image';
import React from 'react';
import { Link } from 'react-router-dom';

export interface ProductCardOverlayProps {
  product: Product;
  fetchProductDetailsRequest: typeof fetchProductDetailsRequest;
  fetchProductReviewsRequest: typeof fetchProductReviewsRequest;
  removeToast: typeof removeToast;
  toasts: ToastWithKeyType;
  CloseDetails: boolean;
  SetCloseDetails: (close: boolean) => void;
  computedProductLink: string;
}

const ProductCardOverlay: React.FC<ProductCardOverlayProps> = ({
  product,
  toasts,
  fetchProductDetailsRequest,
  fetchProductReviewsRequest,
  computedProductLink,
  CloseDetails,
  SetCloseDetails,
}) => {
  return (
    <>
      <div
        className="overflow-hidden rounded-8 cursor-pointer absolute inset-0 "
        onClick={(e) => {
          if (e.target.className.includes('card')) history.push(computedProductLink);
        }}
      >
        {product.inStock === false ? (
          <div className="outOfStock bg-opacity-60 rounded-8 tracking-16 leading-19 h-full w-full absolute text-16">
            <Link to={computedProductLink} className="cursor-pointer">
              <div
                className="text-esteem-price font-semibold flex justify-center items-center h-full text-28"
                font-customisation="para-text"
              >
                Out of stock
              </div>
            </Link>
          </div>
        ) : (
          <div className="relative w-full h-full flex justify-center card md:opacity-0 md:hover:opacity-100">
            <button
              className=" text-textColor absolute bottom-0 right-0 flex"
              onClick={() => {
                fetchProductDetailsRequest(product.slug);
                fetchProductReviewsRequest(product.slug);
                SetCloseDetails(!CloseDetails);
                document.body.style.overflow = 'hidden';
                toasts.length ? toasts.map((t) => removeToast(t.key)) : null;
              }}
            >
              <div
                className="hidden md:flex h-40 w-240 md:w-270 text-16 md:text-20 font-normal md:font-semibold text-page bg-esteem-heading1 md:bg-esteem-colorVariant  items-center text-center justify-center rounded-5 opacity-95 mb-10 mx-10 md:mb-5 md:mx-5"
                font-customisation="para-text"
                button-customisation="page-button"
              >
                Quick View
              </div>
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default ProductCardOverlay;
